module.exports = __webpack_public_path__ + "e5935aabcda17d66cf6b701f1b1f7aa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/picture/Chinese.jpg
// module id = 547
// module chunks = 0